// extracted by mini-css-extract-plugin
export var dropdownIcon = "_mg-6";
export var imgContainer = "_mg-3";
export var menuIcon = "_mg-5";
export var pillWrapper = "_mg-2";
export var pillsContainer = "_mg-1";
export var subscriptionCard = "_mg-0";
export var subscriptionLogo = "_mg-4";